import { useEffect, useRef } from "react";
import { ListeningStatus, MAX_CONTINUOUS_IDLE_MINUTES , MAX_CONTINUOUS_LISTENING_MINUTES } from 'shared/config/constants';

const useListeningWatchdog = ({
  listeningStatus,
  onListeningExceeded,
  onIdleExceeded
}) => {
  const timeoutRef = useRef(null);

  useEffect(() => {
    if (timeoutRef.current) {
      clearTimeout(timeoutRef.current);
      timeoutRef.current = null;
    }

    if (listeningStatus === ListeningStatus.Listening) {
      timeoutRef.current = setTimeout(() => {
        onListeningExceeded?.();
      }, MAX_CONTINUOUS_LISTENING_MINUTES * 60 * 1000); 
    }

    if (listeningStatus === ListeningStatus.Idle) {
      timeoutRef.current = setTimeout(() => {
        onIdleExceeded?.();
      }, MAX_CONTINUOUS_IDLE_MINUTES  * 60 * 1000);
    }

    return () => {
      if (timeoutRef.current) {
        clearTimeout(timeoutRef.current);
      }
    };
  }, [listeningStatus, onListeningExceeded, onIdleExceeded]);
};

export default useListeningWatchdog;